import i18next from 'i18next';

i18next.addResources('en', 'Pagination', {
  page: 'Page'
});
